/**
 * PR 工作台时间区间：请求体 start_time / end_time 的格式化（仅 PR 使用 dateTimeFormat）
 */
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import moment, { Moment } from 'moment';

const PR_API_DATETIME_RULE = 'YYYY-MM-DD HH:mm:ss';

export function formatPrDayRangeForApi(value: [Moment, Moment]): [string, string] {
  return [
    dateTimeFormat(
      value[0].clone().startOf('d').format(PR_API_DATETIME_RULE),
      PR_API_DATETIME_RULE,
    ),
    dateTimeFormat(
      value[1].clone().endOf('d').format(PR_API_DATETIME_RULE),
      PR_API_DATETIME_RULE,
    ),
  ];
}

export function formatPrMonthRangeForApi(value: [Moment, Moment]): [string, string] {
  return [
    dateTimeFormat(
      value[0].clone().startOf('month').format(PR_API_DATETIME_RULE),
      PR_API_DATETIME_RULE,
    ),
    dateTimeFormat(
      value[1].clone().endOf('month').format(PR_API_DATETIME_RULE),
      PR_API_DATETIME_RULE,
    ),
  ];
}

/** PR 月粒度默认：当前自然月（可按业务时区 utcOffset 传入） */
export function getDefaultPrCurrentMonthRange(timeZone = 0): [Moment, Moment] {
  const m = moment().utcOffset(timeZone);
  return [m.clone().startOf('month'), m.clone().endOf('month')];
}

/** PR 日粒度默认：T-0 当天 */
export function getDefaultPrDayT0Range(timeZone = 0): [Moment, Moment] {
  const d = moment().utcOffset(timeZone).startOf('day');
  return [d.clone(), d.clone()];
}
